// removed by extract-text-webpack-plugin
module.exports = {"button":"_3TIb1MPlHkvdQxpeFSZ_eq"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Survey/Button/styles.scss
 ** module id = 421
 ** module chunks = 0
 **/